export const Images = {
    logo:"https://i.ibb.co/7J2WXKr/Travel-Gram-logo.png",
    hero:"https://images.unsplash.com/photo-1561312514-1d71b2b7e495?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    feed_1:"https://images.unsplash.com/photo-1695607379409-bfa72abf6afa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80",
    dp:"https://i.ibb.co/WtdRc06/dp.png",
    feed_2:"https://images.unsplash.com/photo-1582510003544-4d00b7f74220?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    dp2:"https://i.ibb.co/HCYvx08/dp2.png",
    foodies:"https://images.unsplash.com/photo-1592861956120-e524fc739696?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    trekk:"https://plus.unsplash.com/premium_photo-1693639906000-8ac310ebbc5a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    camper:"https://images.unsplash.com/photo-1654913054631-b1106bade06b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    biker:"https://images.unsplash.com/photo-1576858574144-9ae1ebcf5ae5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80",
    monuments:"https://i.ibb.co/25Jg2nt/monuments.png",
    cultures:"https://i.ibb.co/5v50yB0/cultures.png",
    ghats:"https://i.ibb.co/JdrVq43/ghats.png",
    adventure:"https://i.ibb.co/D5FJQtf/adventure.png",
    markets:"https://i.ibb.co/D84fNXW/markets.png",
    local:"https://i.ibb.co/5BCC8TH/delicacies.png",
    icon3:"https://i.ibb.co/dBfD8JP/icon3.png",
    icon2:"https://i.ibb.co/YbSWjM4/icon2.png",
    icon1:"https://i.ibb.co/2KjtNzq/icon1.png",
    dp3:"https://i.ibb.co/vdSYv4Z/dp3.png",
    dp4:"https://i.ibb.co/xhbskXX/dp4.png",
    dp5:"https://i.ibb.co/ZmZD5j1/dp5.png",
    dp6:"https://i.ibb.co/23PmRfd/dp6.png",
    post:"https://images.unsplash.com/photo-1600261669797-1bb7b27939be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2043&q=80",
    hearticon:"https://thenounproject.com/api/private/icons/6138329/edit/?backgroundShape=SQUARE&backgroundShapeColor=%23000000&backgroundShapeOpacity=0&exportSize=752&flipX=false&flipY=false&foregroundColor=%23000000&foregroundOpacity=1&imageFormat=png&rotation=0",
    commenticon:"https://thenounproject.com/api/private/icons/5261875/edit/?backgroundShape=SQUARE&backgroundShapeColor=%23000000&backgroundShapeOpacity=0&exportSize=752&flipX=false&flipY=false&foregroundColor=%23000000&foregroundOpacity=1&imageFormat=png&rotation=0"
}

export const Picture=[
    "https://images.unsplash.com/photo-1600261669797-1bb7b27939be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2043&q=80",
    "https://images.unsplash.com/photo-1627938823193-fd13c1c867dd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    "https://images.unsplash.com/photo-1571536802807-30451e3955d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1840&q=80",
    "https://images.unsplash.com/photo-1627938823193-fd13c1c867dd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    "https://images.unsplash.com/photo-1600261669797-1bb7b27939be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2043&q=80",   
];

export const Ctgry = {
    food:"“The Foodies”",
    trek:"“The Trekkers”",
    camp:"“The Campers”",
    bike:"“The Bikers”",
    monuments:"Historical Monuments",
    cultures:"Cultures & Traditions",
    ghats:"Ghats",
    adventure:"Adventure Sports",
    markets:"Flee Markets",
    local:"Local Delicacies"
}

export const Trends=[
   {"Rank":1,"Location":"#Rishikesh","Name":"Ranbir"},
    {"Rank":2,"Location":"#Uttrakhand","Name":"Virat"},
    {"Rank":3,"Location":"#Jaipur","Name":"Sunny"},
    {"Rank":4,"Location":"#Ujjain","Name":"Incredible India"},
    {"Rank":5,"Location":"#Amazon Rainforest","Name":"Bear Grylls"}
];

export const Api_key = process.env.REACT_APP_API_KEY

export const Unsplash_key= process.env.REACT_APP_UNSPLASH_KEY

export const TrekImages = {
    trek1:"https://indiahikes.com/_next/image?url=https%3A%2F%2Fimages.prismic.io%2Findiahike%2Fc7e7a137-be09-47dc-94f1-ffe502fcf081_Har%2BKi%2BDun_HKD_Ruinsara%2BTal%2B-%2BSubhrajyoti%2BDas%2B-%2BValley%2Bof%2BGods.jpg%3Fauto%3Dcompress%2Cformat%26rect%3D0%2C111%2C1600%2C775%26w%3D1600%26h%3D775&w=1920&q=75",
    trek2:"https://indiahikes.com/_next/image?url=https%3A%2F%2Fimages.prismic.io%2Findiahike%2F74083-Deoriatal-Chandrashila-trek-DC-Lake-The-Mighty-Chaukhamba-Indiahikes-Gourab-Jana-contribution.jpg%3Fauto%3Dcompress%2Cformat&w=1920&q=75",
    trek3:"https://indiahikes.com/_next/image?url=https%3A%2F%2Fimages.prismic.io%2Findiahike%2Fc3000c9e-cf5f-4069-bdce-5f1c475b45b3_Sandakphu_SKP_May%2B2019%2B-%2BIndiahikes%2B-%2BSwathi%2B-%2BSabargram%2BCampsite%2B-%2BSleeping%2BBuddha%2BMountain%2BRange_sunrise_mountains_.jpg%3Fauto%3Dcompress%2Cformat&w=1920&q=75",
    trek4:"https://indiahikes.com/_next/image?url=https%3A%2F%2Fimages.prismic.io%2Findiahike%2F9a4a96d1-434c-4b0c-862e-7e21422cedad_Kedarkantha%2Btrek%2B-%2BSantosh%2BKumar%2B-%2BView%2Bof%2BKedarkantha%2Btop%2B-%2BIndiahikes%2B.jpeg%3Fauto%3Dcompress%2Cformat&w=1920&q=75",
    trek5:"https://indiahikes.com/_next/image?url=https%3A%2F%2Fimages.prismic.io%2Findiahike%2F91614-Brahmatal_BT_GajendraKumar_Brahmatallake_snow_winter_.jpg%3Fauto%3Dcompress%2Cformat&w=1920&q=75",
    road1:"https://img.traveltriangle.com/attachments/pictures/1106556/original/Motorcycle_travelers_ride_in_indian_Himalaya_roads_leh_ladakh.jpg",
    road2:"https://windhorsetour.com/sites/default/files/friendship-highway.jpg",
    road3:"https://img.traveltriangle.com/blog/wp-content/uploads/2017/05/Cover25.jpg",
    road4:"https://www.revv.co.in/blogs/wp-content/uploads/2020/06/Kalimpong.jpg",
    road5:"https://www.esikkimtourism.in/wp-content/uploads/2019/04/buddhaprkoctbr.jpg",
    food1:"https://photos.tpn.to/th/rf/sp/oi/653x490.jpg",
    food2:"https://photos.tpn.to/jk/js/hk/nt/653x490.jpg",
    food3:"https://photos.tpn.to/fn/rl/ll/kr/653x490.jpg",
    food4:"https://photos.tpn.to/tn/ff/gs/he/653x490.jpg",
    food5:"https://photos.tpn.to/em/qh/kl/ge/653x490.jpg"
}


export const Desc ={
    Desc1:"The Best Mix of Ancient Culture and Mountain Beauty on a Trek",
    Desc2:"The Best Summit Views Out Of All Treks",
    Desc3:"The Unforgettable View of Four of the World's Tallest Mountains",
    Desc4:"The Trek with Best Views of Mt Trishul and Mt Nanda Ghunti",
    Desc5:"One of the Finest Summit Climbs for Beginners",
    Desc6:"Route : LEH – LEH",
    Desc7:"Route : Kathmandu – Everest Base Camp",
    Desc8:"Route : West Bengal – Siliguri",
    Desc9:"Route : Delhi – LEH – Srinagar",
    Desc10:"Route : Coimbatore – Hampi – Calicut",
    Desc11:"Enjoy various cooking demonstrations in Cochin, Coorg, Mysore, and Hyderabad",
    Desc12:"Enjoy Holi in Jodhpur, Indian sweets, South Indian Thali at Dasaprakash",
    Desc13:"Coorgi Food, cooking demo, Hyderabadi Biryani and Kebab, Making of Mysore Paak",
    Desc14:"Enjoy cooking demo of Laal Maas, Biryani, Dinner at Coquina restaurant",
    Desc15:"Enjoy food tours, cooking classes, cycling tours, kitchen tours, introduction to spices, city walks."
}

export const Loc ={
    Loc1:"Delhi, Varanasi, Jaipur, Agra",
    Loc2:"Delhi, Udaipur, Jodhpur, Khimsar, Jaipur, Agra",
    Loc3:"Cochin, Calicut, Wayanad, Coorg, Mysore, Bengaluru, Hyderabad",
    Loc4:"Delhi, Agra, Jaipur, Lucknow",
    Loc5:"New Delhi, Agra, Jaipur"
}


export const SuppLang = [{identifier:"en", name:"English"},{identifier:"hindi", name:"Hindi"},{identifier:"spanish", name:"Spanish"}]